import { useQuery } from '@tanstack/react-query';

import { Subsidiary } from '../../domain/static-content/static-content-api.model';
import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import { useUserLocale } from '../../util/locales/use-user-locale';
import { getLocale } from '../../util/locales/locales';

export const useSubsidiary = () => {
  const userLocale = useUserLocale();

  const { key, fetcher } = StaticContentApiService.getSubsidiaryEntryFetcher(
    `subsidiary_${userLocale?.country.toLowerCase()}`,
    getLocale()
  );

  return useQuery([key], fetcher, {
    enabled: !!userLocale,
    select: (response): Subsidiary | undefined => response?.data?.stihlSubsidiaryCollection?.items?.[0],
  });
};
